module.exports = __webpack_public_path__ + "img/101-b-02.prt.bb4e5c98.jpg";